/**
 * Empty-state copy for non-owners who cannot add resources to an agent.
 */
export function getAskAgentOwnerToAddMessage(
  t: (key: string, options?: Record<string, string>) => string,
  resource: string
): string {
  const translated = t('ASK_AGENT_OWNER_TO_ADD', { resource });

  // Prefer i18n only when it actually interpolated the resource.
  if (
    translated &&
    translated !== 'ASK_AGENT_OWNER_TO_ADD' &&
    translated.includes(resource)
  ) {
    return translated;
  }

  // Manual interpolate if the catalog string still has the placeholder.
  if (translated?.includes('{{resource}}')) {
    return translated.replace(/\{\{\s*resource\s*\}\}/g, resource);
  }

  return `Ask the agent owner to add ${resource}.`;
}
